import { Emoji } from 'emoji-mart';

const renderTextWithEmoji = (text: string, size = 20) => {
  const regex = new RegExp('(:[a-zA-Z0-9-_+]+:(:skin-tone-[2-6]:)?)', 'g');

  let lastOffset = 0;
  let matchArr: RegExpExecArray | null;
  const partsOfTheMessageText: (string | React.ReactElement<any>)[] = [];
  while ((matchArr = regex.exec(text)) !== null) {
    const previousText = text.substring(lastOffset, matchArr.index);
    if (previousText.length) partsOfTheMessageText.push(previousText);

    lastOffset = matchArr.index + matchArr[0].length;

    let emoji: React.ReactElement<any> | string | null;
    try {
      emoji = Emoji({
        emoji: matchArr[0],
        html: true,
        set: 'apple',
        size: size
      }) as React.ReactElement<any>;
    } catch (err) {
      emoji = matchArr[0];
    }

    if (emoji) partsOfTheMessageText.push(emoji);
    else partsOfTheMessageText.push(matchArr[0]);
  }

  const finalPartOfTheText = text.substring(lastOffset, text.length);
  if (finalPartOfTheText.length) partsOfTheMessageText.push(finalPartOfTheText);

  return partsOfTheMessageText;
};

export default renderTextWithEmoji;
